module.exports = __webpack_public_path__ + "static/media/IconoPrueba.448573dc.svg";